<template>
	<div class="content_main">
		<div class="content_main_top">
			<a-select placeholder="所属流程" allowClear show-search :filter-option="filterOption" class="a_input_self margin_self"
			 v-model="queryParam.procDefKey" @keyup.enter.native="$refs.table.refresh(true)">
				<a-select-option :value="item.id" v-for="(item, index) in Approvallist" :key="index">
					{{ item.name }}
				</a-select-option>
			</a-select>
			<a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
			<a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
			<a-button v-if="removeEnable" :disabled="!selectedRowKeys.length > 0" type="danger" icon="delete" @click="delByIds(selectedRowKeys)">删除</a-button>
		</div>
		<div class="content_main_center_scroll" id="content_main_center_scroll">
			<s-table size="default" ref="table" rowKey="id" :rowSelection="rowSelection" :columns="columns" :data="loadData"
			 :scroll="{ y: scroll_y }">
				<span slot="result" slot-scope="text">
					{{ text | resultFilter }}
				</span>
				<span slot="action" slot-scope="text, record">
					<a v-if="removeEnable" @click="delByIds([record.id])">删除</a>
				</span>
			</s-table>
		</div>
	</div>
</template>

<script>
	import {
		STable
	} from '@/components'
	import {
		millsToTime
	} from '@/utils/util'
	import {
		getProfInfFinished,
		delHiProcessIns,
		resultMap
	} from '@/api/activiti'
	import {
		checkPermission
	} from '@/utils/permissions'
	import {
		audit_list,
	} from '@/api/financial'
	export default {
		name: 'ProfList',
		components: {
			STable,
		},
		data() {
			return {
				scroll_y: 150,
				visible: false,
				labelCol: {
					xs: {
						span: 24
					},
					sm: {
						span: 5
					},
				},
				wrapperCol: {
					xs: {
						span: 24
					},
					sm: {
						span: 16
					},
				},
				form: this.$form.createForm(this),
				mdl: {},
				permissions: [],
				// 高级搜索 展开/关闭
				advanced: false,
				// 查询参数
				queryParam: {},
				// 表头
				columns: [{
						title: '流程实例ID',
						dataIndex: 'id',
					},
					{
						title: '流程名称',
						dataIndex: 'procName',
					},
					{
						title: '申请人',
						dataIndex: 'applyer',
					},
					{
						title: '标识key',
						dataIndex: 'procDefKey',
					},
					{
						title: '审批结果',
						dataIndex: 'result',
						scopedSlots: {
							customRender: 'result'
						},
					},
					{
						title: '耗时',
						dataIndex: 'duration',
						customRender: (text) => millsToTime(text),
					},
					{
						title: '结束原因',
						dataIndex: 'deleteReason',
					},
					{
						title: '开始时间',
						dataIndex: 'startTime',
					},
					{
						title: '结束时间',
						dataIndex: 'endTime',
					},
					{
						title: '操作',
						width: '150px',
						dataIndex: 'action',
						scopedSlots: {
							customRender: 'action'
						},
					},
				],
				// 加载数据方法 必须为 Promise 对象
				loadData: (parameter) => {
					return getProfInfFinished(Object.assign(parameter, this.queryParam))
				},
				previewVisible: false,
				previewImage: '',
				selectedRowKeys: [],
				selectedRows: [],
				addEnable: checkPermission('activiti:prof:add'),
				editEnabel: checkPermission('activiti:prof:edit'),
				removeEnable: checkPermission('activiti:procInstFinished:delete'),
			}
		},
		computed: {
			rowSelection() {
				return {
					selectedRowKeys: this.selectedRowKeys,
					onChange: this.onSelectChange,
					getCheckboxProps: (record) => ({
						// props: {
						//   disabled: record.deploymentId, // Column configuration not to be checked
						//   name: record.name
						// }
					}),
				}
			},
		},
		filters: {
			resultFilter(result) {
				return resultMap[result]
			},
		},
		created() {
			audit_list().then(res => {
				this.Approvallist = res.data
			})
		},
		mounted() {
			this.$nextTick(() => {
				var max_h = $('#content_main_center_scroll').height()
				setTimeout(() => {
					this.scroll_y = max_h - $('.ant-table-header').height() - 120
				}, 1000)
			})
		},
		methods: {
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
			onSelectChange(selectedRowKeys) {
				this.selectedRowKeys = selectedRowKeys
			},
			handleOk() {
				this.$refs.table.refresh(true)
				console.log('handleSaveOk')
			},
			delByIds(ids) {
				delHiProcessIns({
						ids: ids.join(',')
					})
					.then((res) => {
						if (res.code === 200) {
							this.$message.success(`删除成功`)
							this.handleOk()
						} else {
							this.$message.error(res.msg)
						}
					})
					.finally((this.selectedRowKeys = []))
			},
		},
		watch: {
			/*
			  'selectedRows': function (selectedRows) {
			    this.needTotalList = this.needTotalList.map(item => {
			      return {
			        ...item,
			        total: selectedRows.reduce( (sum, val) => {
			          return sum + val[item.dataIndex]
			        }, 0)
			      }
			    })
			  }
			  */
		},
	}
</script>
